



























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {mixin as clickaway} from 'vue-clickaway';
import {InputVariableViewModel} from '@/features/bots/models/designer';
import AddNewVariableModal from './AddNewVariableModal.vue';
import {dropDownHelper} from '@/shared/components/dropDownMenu/dropDownHelper';
import {ContactAttributeViewModel} from '@/messaging/models/contactAttributeViewModel';
import Icon from '@/shared/icons/Icon.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import AttributeIconUtil from '@/shared/util/attributeIconUtil';
import {ContactAttributeType} from '@/messaging/models/contactAttributeType';
import CreateAttribute from '@/features/settings/components/CreateAttribute.vue';

@Component({
	components: {
		AddNewVariableModal,
		CreateAttribute,
		Icon,
		AddIcon
	},
	mixins: [
		clickaway
	]
})
export default class VariablePicker extends Vue {
	@Prop() public value: InputVariableViewModel;
	@Prop({default: true}) public showButton: boolean;
	@Prop({default: 'right'}) public direction: string;
	@Prop() public open: boolean;
	@Prop({default: false}) public readonly: boolean;
	@Prop() public additionalAttributes!: InputVariableViewModel[];
	@Getter public flowVariables!: InputVariableViewModel[];
	@Getter public contactAttributes!: ContactAttributeViewModel[];
	@Getter public getAttribute!: (attributeId: string) => ContactAttributeViewModel | undefined;

	public selected: InputVariableViewModel;
	public isOpen: boolean = false;
	public showNewVariableModal: boolean = false;
	public showCreateAttributeModal: boolean = false;
	public newVarName: string = '';
	public isUp: boolean = false;

	@Watch('value', { immediate: true })
	public onValueChanged(value: InputVariableViewModel, previous: InputVariableViewModel) {
		this.selected = value;
	}

	@Watch('open', { immediate: true })
	public onDropdownOpenChanged(value: boolean) {
		this.isOpen = value;
		this.positionDropdown();
	}

	public get contactVariables(): InputVariableViewModel[] {
		const contactAttributes = this.contactAttributes.filter(attr => attr.type !== ContactAttributeType.Date).map((attr: ContactAttributeViewModel) => ({
			id: (attr.system ? 'appUser.' : 'appUser.customAttributes.') + attr.id,
			scope: attr.system ? 'appUser' : 'appUser.customAttributes',
			key: attr.id,
			name: attr.name,
			dataType: attr.type
		} as InputVariableViewModel));

		if (this.additionalAttributes) {
			contactAttributes.unshift(...this.additionalAttributes);
		}
		return contactAttributes;
	}

	public getIconComponent(variable: InputVariableViewModel) {
		return AttributeIconUtil.getIcon(variable.dataType, variable.key, this.isSystemAttribute(variable.key));
	}

	public isFlowVariableSelected() {
		return this.selected && this.selected.scope === 'flow';
	}

	public isAppUserVariableSelected() {
		return this.selected && this.selected.scope.startsWith('appUser');
	}

	public getDescription() {
		if (!this.selected) {
			return 'Choose a variable...';
		}

		return this.selected.name;
	}

	public chooseVariable(variable: InputVariableViewModel) {
		this.selected = variable;
		this.$emit('variable-selected', this.selected);
	}

	public closePicker() {
		this.isOpen = false;
		this.isUp = false;
	}

	public togglePicker() {
		this.isOpen = !this.isOpen;
		this.positionDropdown();
	}

	public variableAdded(newVar: InputVariableViewModel) {
		this.chooseVariable(newVar);
		this.closeModal();
	}

	public openNewVariableModal() {
		this.showNewVariableModal = true;
	}

	public closeModal() {
		this.showNewVariableModal = false;
	}

	public getTopDistance() {
		if (this.isUp && !this.showButton) {
			return '-27px';
		} else if (!this.isUp && !this.showButton) {
			return '4px';
		}
		return '0px';
	}

	public openNewAttributeModal() {
		this.showCreateAttributeModal = true;
	}

	public closeAttributeModel(newAttribute?: ContactAttributeViewModel) {
		this.showCreateAttributeModal = false;
		if (newAttribute) {
			const variableForNewAttribute = this.contactVariables.find(attr => attr.key === newAttribute.id);
			if (variableForNewAttribute && variableForNewAttribute.dataType !== ContactAttributeType.Date) {
				this.chooseVariable(variableForNewAttribute);
			}
		}
	}

	private isSystemAttribute(variableId: string) {
		const attribute = this.getAttribute(variableId);
		return attribute ? attribute.system : false;
	}

	private positionDropdown() {
		this.$nextTick(() => this.isUp = dropDownHelper.isDropDownUp());
	}
}
